import React from "react";
import QueriesInfosModal from "@radarly/app/containers/modals/queries-infos";
import QueryList from "@radarly/components/navigation/switcher/search/queries";
import { useSwitcherSearchQueries } from "@radarly/core/navigation/use-cases";
import { useCurrentUserTimezone } from "@radarly/core/user/use-cases";
import { IRouterService } from "@radarly/shared/router";

interface IProps {
  onClickQuery: () => void;
  search: string;
  router: IRouterService;
}

const RadarlySharedNavigationSwitcherSearchQueries = ({
  search,
  onClickQuery,
  router,
}: IProps) => {
  const timezone = useCurrentUserTimezone();
  const {
    queries,
    loading,
    fetchMore,
    canFetchMore,
    toggleIncludeLabel,
    includeQueryBody,
    includeLabel,
    toggleIncludeQueryBody,
    locale,
  } = useSwitcherSearchQueries(search);
  return (
    <QueriesInfosModal>
      {(open) => (
        <QueryList
          queries={queries}
          loading={loading}
          locale={locale}
          onChangeSearchIntoName={toggleIncludeLabel}
          searchIntoName={includeLabel}
          onChangeSearchIntoQuery={toggleIncludeQueryBody}
          searchIntoQuery={includeQueryBody}
          fetchMore={fetchMore}
          canFetchMore={canFetchMore}
          openQueryInfo={open}
          onClickQuery={onClickQuery}
          router={router}
          timezone={timezone}
        />
      )}
    </QueriesInfosModal>
  );
};

export default RadarlySharedNavigationSwitcherSearchQueries;
